export default function(node, x0, x1) {
  this.node = node;
  this.x0 = x0;
  this.x1 = x1;
}
